import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";

export const lynxPaginationStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            marginTop: "20px",
        },

        button: {
            width: "98px !important",
            fontWeight: 600,
            // background: theme.colors.neutrals.white,
            // border: "1px solid white",
            background: "inherit",
            border: "1px solid rgba(39, 10, 220, 0)",
            color: theme.colors.primary.blue500,
            margin: "0px",
            "&:hover": {
                // background: theme.colors.neutrals.white,
                background: "inherit",
                border: `1px solid ${theme.colors.primary.blue500}`,
            },
        },

        buttonDisabled: {
            color: `${theme.colors.neutrals.neutral300} !important`,
        },

        pagination: {
            "& .MuiPagination-ul": {
                // backgroundColor: "white",
                borderRadius: "4px",
            },
            "& .MuiPaginationItem-page.Mui-selected": {
                backgroundColor: theme.colors.primary.blue500,
                color: "white",
                borderRadius: "4px",
                fontWeight: 600,
                "&:hover": {
                    backgroundColor: theme.colors.primary.blue500,
                },
            },
            "&  .MuiPaginationItem-page": {
                marginLeft: "5px",
                // border: `1px solid white`,
                width: "34px !important",
                padding: "7px 14px 7px 14px",
                minWidth: "10px",
                borderRadius: "4px",
                "&:hover": {
                    // backgroundColor: theme.colors.neutrals.white,
                    backgroundColor: "inherit",
                    border: `1px solid ${theme.colors.primary.blue500}`,
                },
            },
        },
    })
);
